module.exports = __webpack_public_path__ + "img/adimg2.92254be1.png";